<script setup lang="ts">
import { ButtonType } from 'vince-ui/types/common';

let editResolve: (value: (PromiseLike<unknown> | unknown)) => void;
let editReject: () => void;

const visible = ref(false);
const value = ref<string>('');
const title = ref<string>('');
const label = ref<string>('');
const cancelButtonLabel = ref<string>('');
const okButtonLabel = ref<string>('');

const show = (popupTitle: string, fieldLabel: string, defaultValue: string, cancelLabel: string, okLabel: string) => {
    return new Promise((resolve, reject) => {
        editResolve = resolve;
        editReject = reject;
        value.value = defaultValue;
        title.value = popupTitle;
        label.value = fieldLabel;
        cancelButtonLabel.value = cancelLabel;
        okButtonLabel.value = okLabel;
        visible.value = true;
    });
};

const cancel = () => {
    visible.value = false;
    editReject();
};

const apply = () => {
    visible.value = false;
    editResolve(value.value);
};

defineExpose({ show });
</script>

<template>
    <VLDialog
        v-model:visible="visible"
        modal
        :closable="false"
        class="w-1/4"
    >
        <template v-if="title" #header>
            <h1 class="font-light">
                {{ title }}
            </h1>
        </template>

        <LabelledField :label="label" class="my-6">
            <VLInputText v-model="value" fluid />
        </LabelledField>

        <template #footer>
            <VButton :label="cancelButtonLabel" @click="cancel" />
            <VButton :label="okButtonLabel" :type="ButtonType.SECONDARY" @click="apply" />
        </template>
    </VLDialog>
</template>
